import { trackClick } from '../ga';
import MainLogo from "../img/mainLogo.svg";
import { useTranslation } from 'react-i18next';
import MainLogoPhone from "../img/mainLogo.svg";
import { NavLink, useLocation } from "react-router-dom";

import {
  ChevronDownIcon,
  CloseIcon,
  HamburgerIcon,
  MoonIcon,
  SunIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Stack,
  useBreakpointValue,
  useColorMode,
  useDisclosure,
  useColorModeValue,Link
} from "@chakra-ui/react";

export default function Nav() {
  const orgColor = "#ec562c";
  const bluColor = "#2f4280";
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const { i18n, t } = useTranslation();
  const imageSrc = useBreakpointValue({ base: MainLogoPhone, md: MainLogo });
  const location = useLocation();
  const isHome = location.pathname === "/";

  const toggleLang = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.dir = newLang === "ar" ? "rtl" : "ltr";
  };

  const menuItems = [
    { label: t("navbar.home"), to: "/" },
    { label: t("navbar.about"), to: "/about" },
    { label: t("navbar.services"), to: "/services" },
    { label: t("navbar.fleet"), to: "/fleet" },
    { label: t("navbar.contact"), to: "/contact" },
    { label: t("navbar.login"), to: "/admin/login" },
  ];
  {localStorage.getItem("isAdmin") ? (
    <Link to="/admin/messages">Messages</Link>
  ) : (
    <Link to="/admin/login">Admin Login</Link>
  )}

    const trackOnClick = (action) => {
    console.log(`Tracking click: ${action}`);
    trackClick.ReactGA.event({
      category: 'User',
      action: action,
    });
  };
  //   onClick={() => trackOnClick(`Clicked ${item.label}`)}

  return (
    <Box
      bg={isHome ? "transparent" : ("white")}
      position={isHome ? "absolute" : "relative"}
      top="0"
      left="0"
      w="100%"
      zIndex="1000"
      boxShadow={isHome ? "none" : "sm"}
    >
      <Container maxW="container.xl" py={2}>
        <Flex alignItems="center" justifyContent="space-between">
          {/* Mobile Hamburger */}
          <IconButton
            aria-label="Toggle Menu"
            bg="none"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            onClick={isOpen ? onClose : onOpen}
            display={{ base: "block", md: "none" }}
          />

          {/* Logo */}
          <Flex align="center">
            <Image src={imageSrc} alt="Main logo" h="80px"  onClick={() => trackClick(`Clicked LOGO`)}/>
            
          </Flex>

          {/* Desktop Menu */}
          <HStack as="nav" spacing={1} display={{ base: "none", md: "flex" }}>
            {menuItems.map((item) => (
              <Button
                key={item.to}
                as={NavLink}
                to={item.to}
                variant="ghost"
                fontWeight="medium"
                onClick={() => trackClick(`Clicked ${item.label}`)}
                _hover={{ color: orgColor }}
                style={({ isActive }) =>
                  isActive ? { fontWeight: "bold", color: orgColor } : {}
                }
              >
                {item.label}
              </Button>
            ))}
          </HStack>

          {/* Right Section */}
          <HStack spacing={2}>
            {/* <Button onClick={toggleColorMode} bg="none">
              {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            </Button> */}
            <Button size="md" onClick={toggleLang}>
              {i18n.language === "ar" ? "English" : "عربي"}
            </Button>
          </HStack>
        </Flex>

        {/* Mobile Menu Overlay */}
        {isOpen && (
          <Box
            display={{ md: "none" }}
            bg={"#fff"}
            position="absolute"
            top="100%"
            left="0"
            w="100%"
            py={4}
            px={4}
            boxShadow="md"
          >
            <Stack spacing={4}>
              {menuItems.map((item) => (
                <Button
                  key={item.to}
                  as={NavLink}
                  to={item.to}
                  variant="ghost"
                  w="100%"
                  justifyContent="flex-start"
                  onClick={onClose}
                >
                  {item.label}
                </Button>
              ))}
            </Stack>
          </Box>
        )}
      </Container>
    </Box>
  );
}